import Vue from 'vue';
import geCode from '../src';
import Demo from './demo.vue'
new Vue({
	el: '#app',
	 render: (h) => h(Demo)
})